import './styles/main.css';

import 'hammerjs';

import VueTouch from 'vue-touch';
import VueParallaxJs from 'vue-parallax-js';

import HeaderImage from './js/components/header-image.component';
import EventsSection from './js/components/events-section.component';
import QuotesSection from './js/components/quotes-section.component';

let Vue;

if (process.env.NODE_ENV === 'development') {
  Vue = require('vue/dist/vue');
} else {
  Vue = require('vue/dist/vue.min');
}

Vue.use(VueParallaxJs, {minWidth: 1024});
// import registerServiceWorker from './registerServiceWorker';


// Set up Vue Touch
// ----------------

Vue.use(VueTouch);

// Limit swiping to 'horizontal', so that it won't conflict with vertical page scrolling:
// https://github.com/vuejs/vue-touch/issues/81#issuecomment-300405757
VueTouch.config.swipe = {
  direction: 'horizontal'
};


// Component registration
// ----------------------

Vue.component('header-image', HeaderImage);
Vue.component('events-section', EventsSection);
Vue.component('quotes-section', QuotesSection);


// Vue initialization
// ------------------

new Vue({
  el: '#root'
});


// Service worker registration
// ---------------------------

// Requires https:
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js